import { css } from '@emotion/core'
import { ChatArea, NavBottomPadding } from '@styles/base.style'
import styled, { Theme } from '@themes/theme'
import { UserPickBannerH } from '../BettingHistoryListItem/index.style'

export const BetHistoryWrap = styled.div`
  ${ChatArea};
  position: relative;
  top: 0;
  width: 100%;
  height: 100%;
  margin-top: 5px;
  margin-bottom: 0; // 모바일에서 하단에 과도하게 높아지는 부분 제거.
  padding: 0 14px;
  &:not(.pc, .full-modal) {
    padding-bottom: ${NavBottomPadding};
  }
  .am-list {
    .am-list-body {
      background: none;
    }
  }
  .am-list-view-scrollview-content.am-list {
    width: 100%;
  }
  &.full-modal {
    position: absolute;
    top: 270px;
    height: calc(100% - 315px);
    &.no-banner{
      top: 210px;
      height: calc(100% - 255px);
    }
    .am-list {
      //  height: calc(100% - 180px); // 풀모달일때 하단에 데이터 로딩 애니메이션 보여지게 하기 위해.
      height: 100%;
    }
  }
  &.pc {
    position: absolute;
    top: 285px;
    height: calc(100% - 150px);
    &.no-banner{
      top: 215px;
      height: calc(100% - 80px);
    }
    .am-list {
      //height: calc(100% - (180px + ${UserPickBannerH}));
      height: calc(100% - 180px);
    }
    .am-list-view-scrollview-content.am-list {
      height: auto;
    }
    .list-view-section-body {
      // padding-bottom: 50px; // 하단에 과도하게 높아지는 부분 제거.
    }

  }
  // 모바일 삭제모드
  &.m-delete-mode {
    margin-bottom: 40px;
  }
  // pc 삭제모드
  &.pc-delete-mode {
    max-height: calc(100% - 40px);
  }

  // 베팅내역 상단 배너 없을 경우
  &.no-banner {
    &.pc {
      .am-list {
        height: calc(100% - 180px);
      }
    }
  }
`
export const keepBetListBtnStyle = (theme:Theme) => css`
  position: absolute;
  top: 50%;
  transform: translate3d(0, -50%, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  background: none;
  .keep-btn-bg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${theme.color.modalBg};
  }
  .keep-ico {
    position:relative;
    width: 14px;
    height: auto;
  }
`
export const BettingHistoryOptionWrapStyle = css`
  //position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 24px 0 14px;
  .refresh-btn {
    position: absolute;
    top: 172px;
    width: 30px;
    height: 30px;
    background: none;
    &.pc{
      top: 142px;
    }
    &.full-modal{ // 배팅내역 배너삽입으로 인해 위치 변경
      top: 141px;
    }
    .refresh-ico {
      width: 24px;
      height: auto;
    }
    &.disabled {
      opacity: .3;
    }
  }
`
